// removed by extract-text-webpack-plugin
module.exports = {"squiggle":"src-components-squiggle----style-module---squiggle---2QPWR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/squiggle/style.module.scss
// module id = 51
// module chunks = 35783957827783 214841128528381 257454202316256